import React, { useEffect } from "react";
import { connect } from "react-redux";
import OurDoctorAction from "./OurDoctorAction";
import "./ourDoctors.css";
import Footer from "../../components/Footer/Footer";
import NewHeader from "../../components/NewHeader/NewHeader";

const aboutDoctors = [
  {
    professional_abbr:"Dr",
    profile_picture:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/5322a4d3-6c08-4274-b135-ae47a9c8a85c.png",
    name: "Priti Sonkar",
    qualification: "MD Pathology",
    specialization: "Consultant Pathologist – Redcliffe Labs",
    discription:
      "She has more than 10 years of Professional experience in the field of Pathology and has been associated with leading medical laboratories & reputed medical colleges. Prior to Redcliffe Labs, She was associated with Yashoda Superspeciality Hospital, Ghaziabad. In her present assignment at Redcliffe Labs, she is responsible for handling Hematology, Clinical Pathology, Cytopathology, Biochemistry, Immunology and Internal / External quality assurance programs.​",
  },
  {
    professional_abbr:"Dr",
    profile_picture:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/5322a4d3-6c08-4274-b135-ae47a9c8a85c.png",
    name: "Priti Sonkar",
    qualification: "MD Pathology",
    specialization: "Consultant Pathologist – Redcliffe Labs",
    discription:
      "She has more than 10 years of Professional experience in the field of Pathology and has been associated with leading medical laboratories & reputed medical colleges. Prior to Redcliffe Labs, She was associated with Yashoda Superspeciality Hospital, Ghaziabad. In her present assignment at Redcliffe Labs, she is responsible for handling Hematology, Clinical Pathology, Cytopathology, Biochemistry, Immunology and Internal / External quality assurance programs.​",
  },
  {
    professional_abbr:"Dr",
    profile_picture:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/5322a4d3-6c08-4274-b135-ae47a9c8a85c.png",
    name: "Priti Sonkar",
    qualification: "MD Pathology",
    specialization: "Consultant Pathologist – Redcliffe Labs",
    discription:
      "She has more than 10 years of Professional experience in the field of Pathology and has been associated with leading medical laboratories & reputed medical colleges. Prior to Redcliffe Labs, She was associated with Yashoda Superspeciality Hospital, Ghaziabad. In her present assignment at Redcliffe Labs, she is responsible for handling Hematology, Clinical Pathology, Cytopathology, Biochemistry, Immunology and Internal / External quality assurance programs.​",
  },
];

const OurDoctors = (props) => {
  useEffect(() => {
    props.getAllDoctors();
  }, []);

  console.log(props.alldoctorsDetails, "<<<<<<");

  return (
    <>
      <NewHeader />
      <div className="headerBanner">
        <img src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/aab384fe-cdb7-45b3-bd51-5cf08b41c64a.png" />
        <h1>Our Doctors, Clinicians and Scientific Team</h1>
      </div>
      <div className="container">
        <div className="grid_box">
          {props?.alldoctorsDetails?.map((item) => {
            return (
              <div className="grid_docotr_card">
                <div className="card_upper_section">
                  <div className="doctor_image">
                    <img src={item?.profile_picture} alt="doctor image" />
                  </div>
                  <div className="doctor_bio">
                    <h2>{item?.professional_abbr}. {item?.name}</h2>
                    <p>{item?.qualification}</p>
                    <p>{item?.specialization}</p>
                  </div>
                </div>
                <div className="card_lower_section">
                  <p>{item?.discription}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  alldoctorsDetails: state.DoctorsReducer.doctorsDetails,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getAllDoctors: () => {
      dispatch(OurDoctorAction.getAllDoctors());
    },
  };
};

export default {
  component: connect(
    mapStateToProps,
    mapDispatchToProps
  )(OurDoctors)
};
